exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dyna-app-share-buttons {\n  justify-content: center;\n  margin: 24px 0;\n  opacity: 0.5;\n}\n", ""]);

// exports
